import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Anchor, Box, Button, Heading, Image, Text, Markdown } from "grommet";
import * as React from "react";
import styled from "styled-components";
import ScrollContainer from "../components/ScrollContainer";
import StyledModal from "../components/StyledModel";
import { GameViewModel, getGames } from "../games/GamesStore";
import { GameCard } from "../games/GameCard";
const twitter = <FontAwesomeIcon size="lg" icon={["fab", "twitter"]}></FontAwesomeIcon>;
const facebook = <FontAwesomeIcon size="lg" icon={["fab", "facebook"]}></FontAwesomeIcon>;
const web = <FontAwesomeIcon size="lg" icon={["fad", "globe"]}></FontAwesomeIcon>;

const SocialIconMap = {
    twitter: twitter,
    facebook: facebook,
    web: web,
};

const GameBox = styled.span`
    scale: 1;
    transition: all 0.3s ease;
    :hover {
        cursor: pointer;
        scale: 1.2;
        z-index: 10;
    }
`;

const GameCollection = () => {
    const [games, setGames] = React.useState([] as GameViewModel[]);
    const [currentGame, setCurrentGame] = React.useState({} as GameViewModel);
    const [showGameInfo, setShowGameInfo] = React.useState(false);
    const [hovered, setHovered] = React.useState(0);
    const [opacity, setOpacity] = React.useState("strong");
    const [textColor, setTextColor] = React.useState("text");
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        getGames().then((result) => {
            setGames(result);
            setLoading(false);
        });
    }, []);

    const showGame = (game) => {
        setCurrentGame(game);
        setShowGameInfo(true);
    };

    return (
        <div>
            <Box align="center" pad="large" gap="medium">
                <Text weight={"bold"} style={{ textTransform: "uppercase" }}>
                    Our Game Collection
                </Text>
                <Box direction="row" gap="small" wrap justify="center" pad={{ bottom: "100px" }}>
                    {games.map((game, i) => (
                        <Box onClick={() => showGame(game)}>
                            <GameCard game={game}></GameCard>
                        </Box>
                    ))}
                </Box>

                <StyledModal isOpen={showGameInfo} setIsOpen={setShowGameInfo}>
                    <ScrollContainer direction={"-y"}>
                        {showGameInfo && (
                            <Box width={"large"}>
                                <Heading level={2}>{currentGame.name}</Heading>
                                <Image src={currentGame.splashUri} height="300" style={{ maxHeight: "300px" }} fit="cover"></Image>
                                <Text size="small">{currentGame.description}</Text>
                                <Markdown>{currentGame.about}</Markdown>

                                <Box gap="small">
                                    {currentGame.gameMedia.screenshots?.map((screenshot, i) => (
                                        <Image key={i} src={screenshot} width="560" height="315"></Image>
                                    ))}
                                    {currentGame.gameMedia.videos?.map((video, i) => (
                                        <iframe key={"v" + i} width="560" height="315" src={video} frameBorder="0" allowFullScreen></iframe>
                                    ))}
                                </Box>
                                <Box direction="row" gap="small" align="center" justify="center" pad={"small"}>
                                    {currentGame.gameMedia.socialMediaLinks?.map((social, i) => (
                                        <Anchor key={"a" + i} href={social.link}>
                                            {SocialIconMap[social.icon]}
                                        </Anchor>
                                    ))}
                                </Box>
                                <Button label="Close" onClick={() => setShowGameInfo(false)}></Button>
                            </Box>
                        )}
                    </ScrollContainer>
                </StyledModal>
            </Box>
        </div>
    );
};

export default GameCollection;

{
    /* <GameBox key={game.name} onMouseEnter={() => (setHovered(i), setOpacity("weak"), setTextColor("background-front"))} onMouseLeave={() => (setOpacity("strong"), setTextColor("text"))}>
<Box key={i} pad="small" gap="small" background={"background-back"} hoverIndicator="background-front" onClick={showGame(game)} margin={{ top: "small" }}>
    <Image src={game.logoUri} width="250" fit="cover" opacity={hovered == i ? "strong" : opacity}></Image>
    <Text color={hovered == i ? "text" : textColor}>{game.name}</Text>
</Box>
</GameBox> */
}
